'use client';

import { useMemo } from 'react';

import { useTimeSince } from '@personly/libs-hooks';

interface Props {
  locale: string;
  value: string;
  placeholder: string;
}

const Expires = ({ locale, value, placeholder }: Props) => {
  const days = parseInt(value, 10);
  const interval = Date.now() - days * 24 * 60 * 60 * 1000;
  const timeSince = useTimeSince(locale, interval);

  const toExpires = useMemo(
    () => (days === 0 ? placeholder : timeSince),
    [placeholder, timeSince, days]
  );

  return toExpires;
};

export default Expires;
